import {
  EWebAnalyticsCompareMode,
  type IWebAnalyticsPeriod,
} from '@mahawi/eshop-common';
import { Select, Space } from 'antd';
import React from 'react';

import { type IDateRange } from '../../fragments/date-range';
import {
  fromWebAnalyticsPeriod,
  getWebAnalyticsEndBefore,
  toWebAnalyticsPeriod,
  WEB_ANALYTICS_DATE_RANGE_PRESETS,
} from '../../reducers/web-analytics-insights/period';
import { SPACING } from '../../theme/tokens';
import DateRangeFilter from '../date-range-filter';

export const COMPARE_OPTIONS: {
  value: EWebAnalyticsCompareMode;
  label: string;
}[] = [
  { value: EWebAnalyticsCompareMode.NONE, label: 'No comparison' },
  { value: EWebAnalyticsCompareMode.PREVIOUS_PERIOD, label: 'Previous period' },
  { value: EWebAnalyticsCompareMode.PREVIOUS_YEAR, label: 'Previous year' },
];

function PeriodPicker({
  period,
  onChange,
  disabled,
}: {
  period: IWebAnalyticsPeriod;
  onChange: (period: IWebAnalyticsPeriod) => void;
  disabled: boolean;
}): React.ReactElement {
  return (
    <Space size={SPACING.lg} align="start" wrap>
      <DateRangeFilter
        value={fromWebAnalyticsPeriod(period)}
        presets={WEB_ANALYTICS_DATE_RANGE_PRESETS}
        endBefore={getWebAnalyticsEndBefore()}
        disabled={disabled}
        onChange={(range: IDateRange): void => {
          onChange(toWebAnalyticsPeriod(range, period.compare));
        }}
      />

      <Select<EWebAnalyticsCompareMode>
        value={period.compare}
        options={COMPARE_OPTIONS}
        style={{ width: 180 }}
        disabled={disabled}
        onChange={(compare: EWebAnalyticsCompareMode): void => {
          onChange({ ...period, compare });
        }}
      />
    </Space>
  );
}

export default PeriodPicker;
